// Dependencies
import { createGlobalStyle } from 'styled-components';

const OlarkStyles = createGlobalStyle`
  html body #olark-wrapper {
    .olark-launch-button-wrapper {
      z-index: 999 !important;

      .olark-button-focus-wrapper:focus-within {
        background-color: transparent !important;
      }

      .olark-launch-button {
        clip-path: none !important;
        border-radius: 100% !important;
        min-width: 0 !important;
        background-color: var(--color-beige) !important;
        box-shadow: 0.313rem 0.313rem 0.625rem 0.313rem rgba(0, 0, 0, 0.05) !important;


        .olark-close-icon path,
        .olark-envelope-icon path,
        .olark-envelope-icon rect {
          stroke: var(--color-bark) !important;
        }
      }
    }

    #olark-container.olark-no-branding {
      right: 0 !important;
      bottom: 5.875rem !important;
      border-radius: 0 !important;
      border: none !important;
      z-index: 900 !important;

      .olark-top-bar {
        padding: 1.2rem 2.25rem !important;
        border-radius: 0 !important;
        border: none !important;
        background-color: var(--color-beige) !important;

        .olark-top-bar-text {
          font-family: var(--font-quasimoda) !important;
          font-size: 1.25rem;
          font-weight: var(--font-weight-regular) !important;
          text-transform: uppercase !important;
          color: var(--color-charcoal) !important;
        }

        p {
          font-family: var(--font-quasimoda) !important;
          font-size: 0.875rem !important;
          color: var(--color-charcoal) !important;
        }
      }

       .olark-survey-form {
          padding: 1.2rem 2.25rem !important;

          .olark-survey-form-welcome {
            display: none !important;
          }

          .olark-survey-form-label {
            margin: 2rem 0 0.1rem 0 !important;
            font-family: var(--font-quasimoda) !important;
            font-size: 0.8rem;
            color: var(--color-charcoal) !important;
          }

          .olark-survey-form-info-message {
            margin: 0.5rem 0 1rem 0 !important;
            font-family: var(--font-quasimoda) !important;
            text-align: left !important;
            color: var(--color-charcoal) !important;
          }

          .olark-survey-form-error-msg {
            display: none !important;
          }

          .olark-survey-form-item {
            .olark-survey-form-req-icon {
              display: none !important;
            }
          }

          .olark-survey-form-input {
            padding: 0.5rem 1rem 0.5rem 0.25rem !important;
            border-top: none !important;
            border-right: none !important;
            border-bottom: 0.0625rem solid var(--color-charcoal) !important;
            border-left: none !important;
            border-radius: 0 !important;
            font-family: var(--font-quasimoda) !important;
            font-size: 1rem !important;
            color: var(--color-charcoal) !important;

            &::placeholder {
              color: var(--color-bark) !important;
            }

            &:focus {
              box-shadow: none !important;
            }
          }

          .olark-button {
              margin: 2rem 0 0.5rem 0 !important;
              font-weight: var(--font-weight-light) !important;
              background-color: var(--color-charcoal) !important;
              border-radius: 0 !important;

              &:focus {
                border: none !important;
              }
          }
       }

       .olark-survey-form-has-error .olark-survey-form-input {
          border-color: var(--color-error) !important;
       }

      .olark-branding-link svg path {
        fill: var(--color-charcoal) !important;
      }

      .olark-thank-you-component {
        border: none !important;
        border-radius: 0 !important;

        svg {
          display: none !important;
        }

        span {
          max-width: 16rem !important;
          padding: 0 20px !important;
          font-family: var(--font-quasimoda) !important;
          font-weight: var(--font-weight-medium) !important;
          font-size: 1.2rem !important;
          line-height: 1.7 !important;
          color: var(--color-charcoal) !important;
        }
      }

      .olark-overlay-module-container {
        border-radius: 0 !important;
      }

      &:focus:not(.olark-inline) {
        border-color: transparent !important;
      }
    }

    @media screen and (min-width: 1100px) {
      #olark-container {
        right: 1.25rem !important;

        &:focus:not(.olark-inline) {
          bottom: 5.875rem !important;
        }
      }
    }
`;

export default OlarkStyles;
